import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingExternalBarn = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["ExternalBarn" + level];
    return BF2GetConfigBasedOutskirtBuilding(config);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingExternalBarn.ts
// module id = 2162
// module chunks = 3